module.exports = __webpack_public_path__ + "img/sdg_es_(4).35087d1e.png";